
$ ->
	$('#paymentSessionForm input[name=number]').payment('formatCardNumber')

	$('#paymentSessionForm').submit ->
		ccType = $.payment.cardType($('input[name=number]').val())
		if !$.payment.validateCardNumber($('input[name=number]').val())
			alertDialog($('h1').text(), tr('Invalid credit card number.'))
			return false
		if !$.payment.validateCardCVC($('input[name=cvc]').val(), ccType)
			alertDialog($('h1').text(), tr('Invalid credit card security code (CVV).'))
			return false

		$('#paymentSessionForm .panel-footer button').prop('disabled', true)
		$('#paymentSessionForm .panel-footer button span').replaceWith('<span class="icon-spin3 animate-spin"></span>')

		$.post(document.location.href, $(this).serialize(), (data) ->
			if data.result == 'ok' or data.result == 'already_done'
				BootstrapDialog.show({
					type:     BootstrapDialog.TYPE_SUCCESS,
					closable: false
					title:    '<span class="glyphicon glyphicon-ok"></span> '+tr('Congratulations %name%!', {'name': g_userFirstName}),
					message:  tr('We collected your game stake successfuly, you will receive a confirmation email in a few minutes.'),
					buttons: [
						{
							label: tr('Go to my account'),
							icon:  'glyphicon glyphicon-user',
							action: (dialog) ->
								document.location.href = g_userProfile
						}
					]
				})
			else if data.result == 'failed'
				if g_mode == 'pay'
					msg = tr('Your game stake payment has failed.')
				else
					msg = tr('Update of your credit card has failed.')
				#endif
				msg += tr('Please check that your credit card is valid and you have the funds on your account.')

				BootstrapDialog.show({
					type:     BootstrapDialog.TYPE_DANGER,
					title:    '<span class="glyphicon glyphicon-remove"></span> '+tr('Stake payment failed'),
					message:  msg,
					buttons: [
						{
							label: tr('Retry'),
							icon:  'glyphicon glyphicon-repeat',
							action: (dialog) ->
								dialog.close()
						}
					]
				})
			else if data.result == 'willRetry'
				BootstrapDialog.show({
					type:     BootstrapDialog.TYPE_WARNING,
					closable: false
					title:    '<span class="glyphicon glyphicon-warning-sign"></span> '+tr('Insufficient funds'),
					message:  tr('Your game stake payment has failed due to insufficient funds on your account. You will integrate our community as soon as your stake is collected.'),
					buttons: [
						{
							label: tr('Go to my account'),
							icon:  'glyphicon glyphicon-user',
							action: (dialog) ->
								document.location.href = g_userProfile
						}
					]
				})
			else if data.result == 'cardExists'
				errorDialog(tr('Credit card already used'), tr('This credit card number is already registered for another client. Please contact the customer service.'))
			else
				panicDialog('Failed to process payment/update, unknown result \''+data.result+'\'.')
			#endif
		, 'json').fail(->
			panicDialog('Failed to process payment/update')
		).always(->
			$('#paymentSessionForm .panel-footer button').prop('disabled', false)
			$('#paymentSessionForm .panel-footer button span').replaceWith('<span class="glyphicon glyphicon-ok"></span>')
		)

		return false
	#endfunc
